import React, { useMemo } from "react";

/**
 * LifeNHealthHeaderBanner
 * Controlled component – parent owns selectedId + onSelect.
 */

export const PRODUCTS = [
  {
    id: "maternity",
    emoji: "🤰",
    label: "MaternityCare",
    eyebrow: "Pregnancy Journey Data Companion",
    subtitle: "Always with you, from the first flutter to the first cry",
    theme: {
      headerFrom: "#FCE8EF",
      headerVia: "#F8EDD9",
      headerTo: "#E8C9F0",
      topBar: "from-[#F8C1D0] via-[#F5D5A8] to-[#E8C9F0]",
      badgeBg: "#eb88a9",
      titleGradient: "from-[#C07A9A] via-[#D4A0B8] to-[#B88BC8]",
      heart: "#E07A9A",
      subtitle: "#6E5585",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#FFF8F0_0%,#F8E0EC_40%,#E8D0F5_75%,#D8C0F0_100%)",
      orbitFrom: "#F8E9FF",
      orbitTo: "#EEDCFA",
      glow: "rgba(232,180,200,0.45)",
      lineStart: "#E8A0B8",
      lineEnd: "#D4C0F0",
      // page-level tokens
      pageFrom: "#FCE8EF",
      pageVia: "#F8EDD9",
      pageTo: "#F3E8FF",
      textPrimary: "#3D2168",
      textSecondary: "#6E5585",
      accent: "#C07A9A",
      accentSoft: "#FCE8EF",
      accentBorder: "#E8A0B8",
    },
  },
  {
    id: "childgrowth",
    emoji: "🌱",
    label: "ChildGrowth",
    eyebrow: "Anvaya Growth Companion",
    subtitle: "Nurturing every milestone from first steps to first dreams",
    theme: {
      headerFrom: "#E8F5E9",
      headerVia: "#F1F8E9",
      headerTo: "#C8E6C9",
      topBar: "from-[#A5D6A7] via-[#C5E1A5] to-[#81C784]",
      badgeBg: "#66BB6A",
      titleGradient: "from-[#2E7D32] via-[#43A047] to-[#66BB6A]",
      heart: "#43A047",
      subtitle: "#4A6741",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#F1F8E9_0%,#DCEDC8_40%,#C8E6C9_75%,#A5D6A7_100%)",
      orbitFrom: "#E8F5E9",
      orbitTo: "#C8E6C9",
      glow: "rgba(129,199,132,0.45)",
      lineStart: "#81C784",
      lineEnd: "#A5D6A7",
      pageFrom: "#E8F5E9",
      pageVia: "#F1F8E9",
      pageTo: "#E8F5E9",
      textPrimary: "#1B5E20",
      textSecondary: "#4A6741",
      accent: "#43A047",
      accentSoft: "#E8F5E9",
      accentBorder: "#81C784",
    },
  },
  {
    id: "balance",
    emoji: "🩸",
    label: "BalanceDiabetes",
    eyebrow: "Balance • Diabetes Companion",
    subtitle: "Steady numbers, calmer days, stronger you",
    theme: {
      headerFrom: "#FFEBEE",
      headerVia: "#FFF3E0",
      headerTo: "#FFCDD2",
      topBar: "from-[#EF9A9A] via-[#FFAB91] to-[#E57373]",
      badgeBg: "#E57373",
      titleGradient: "from-[#C62828] via-[#E53935] to-[#EF5350]",
      heart: "#E53935",
      subtitle: "#6D4C41",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#FFF8F0_0%,#FFCCBC_40%,#FFCDD2_75%,#EF9A9A_100%)",
      orbitFrom: "#FFEBEE",
      orbitTo: "#FFCDD2",
      glow: "rgba(239,154,154,0.45)",
      lineStart: "#EF9A9A",
      lineEnd: "#FFAB91",
      pageFrom: "#FFEBEE",
      pageVia: "#FFF3E0",
      pageTo: "#FFEBEE",
      textPrimary: "#B71C1C",
      textSecondary: "#6D4C41",
      accent: "#E53935",
      accentSoft: "#FFEBEE",
      accentBorder: "#EF9A9A",
    },
  },
  {
    id: "vital",
    emoji: "❤️‍🔥",
    label: "VitalCardio",
    eyebrow: "Vital • Heart Health Companion",
    subtitle: "Protecting the rhythm that keeps you going",
    theme: {
      headerFrom: "#FCE4EC",
      headerVia: "#F8BBD0",
      headerTo: "#F48FB1",
      topBar: "from-[#F48FB1] via-[#F06292] to-[#EC407A]",
      badgeBg: "#EC407A",
      titleGradient: "from-[#AD1457] via-[#C2185B] to-[#E91E63]",
      heart: "#E91E63",
      subtitle: "#6A1B4D",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#FFF0F5_0%,#F8BBD0_40%,#F48FB1_75%,#F06292_100%)",
      orbitFrom: "#FCE4EC",
      orbitTo: "#F8BBD0",
      glow: "rgba(244,143,177,0.45)",
      lineStart: "#F48FB1",
      lineEnd: "#F06292",
      pageFrom: "#FCE4EC",
      pageVia: "#F8BBD0",
      pageTo: "#FCE4EC",
      textPrimary: "#880E4F",
      textSecondary: "#6A1B4D",
      accent: "#E91E63",
      accentSoft: "#FCE4EC",
      accentBorder: "#F48FB1",
    },
  },
  {
    id: "herlife",
    emoji: "🌸",
    label: "HerLifeW30+",
    eyebrow: "HerLife • Women 30+ Companion",
    subtitle: "Honoring every chapter of your womanhood",
    theme: {
      headerFrom: "#F3E5F5",
      headerVia: "#FCE4EC",
      headerTo: "#E1BEE7",
      topBar: "from-[#CE93D8] via-[#F48FB1] to-[#BA68C8]",
      badgeBg: "#AB47BC",
      titleGradient: "from-[#6A1B9A] via-[#8E24AA] to-[#AB47BC]",
      heart: "#AB47BC",
      subtitle: "#4A148C",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#FDF4FF_0%,#F3E5F5_40%,#E1BEE7_75%,#CE93D8_100%)",
      orbitFrom: "#F3E5F5",
      orbitTo: "#E1BEE7",
      glow: "rgba(206,147,216,0.45)",
      lineStart: "#CE93D8",
      lineEnd: "#BA68C8",
      pageFrom: "#F3E5F5",
      pageVia: "#FCE4EC",
      pageTo: "#F3E5F5",
      textPrimary: "#4A148C",
      textSecondary: "#6A1B9A",
      accent: "#AB47BC",
      accentSoft: "#F3E5F5",
      accentBorder: "#CE93D8",
    },
  },
  {
    id: "breathe",
    emoji: "🫁",
    label: "Breathe",
    eyebrow: "Breathe • Respiratory Companion",
    subtitle: "Clearer airways, freer moments, deeper calm",
    theme: {
      headerFrom: "#E3F2FD",
      headerVia: "#E0F7FA",
      headerTo: "#B3E5FC",
      topBar: "from-[#81D4FA] via-[#4FC3F7] to-[#29B6F6]",
      badgeBg: "#29B6F6",
      titleGradient: "from-[#0277BD] via-[#0288D1] to-[#039BE5]",
      heart: "#039BE5",
      subtitle: "#01579B",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#E1F5FE_0%,#B3E5FC_40%,#81D4FA_75%,#4FC3F7_100%)",
      orbitFrom: "#E3F2FD",
      orbitTo: "#B3E5FC",
      glow: "rgba(129,212,250,0.45)",
      lineStart: "#81D4FA",
      lineEnd: "#4FC3F7",
      pageFrom: "#E3F2FD",
      pageVia: "#E0F7FA",
      pageTo: "#E3F2FD",
      textPrimary: "#01579B",
      textSecondary: "#0277BD",
      accent: "#039BE5",
      accentSoft: "#E3F2FD",
      accentBorder: "#81D4FA",
    },
  },
  {
    id: "sahara",
    emoji: "🌿",
    label: "Sahara60+",
    eyebrow: "Sahara • 60+ Wellness Companion",
    subtitle: "Graceful years, vibrant living, steady strength",
    theme: {
      headerFrom: "#E8F5E9",
      headerVia: "#F1F8E9",
      headerTo: "#DCEDC8",
      topBar: "from-[#AED581] via-[#9CCC65] to-[#8BC34A]",
      badgeBg: "#7CB342",
      titleGradient: "from-[#33691E] via-[#558B2F] to-[#689F38]",
      heart: "#689F38",
      subtitle: "#33691E",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#F1F8E9_0%,#DCEDC8_40%,#C5E1A5_75%,#AED581_100%)",
      orbitFrom: "#E8F5E9",
      orbitTo: "#C5E1A5",
      glow: "rgba(174,213,129,0.45)",
      lineStart: "#AED581",
      lineEnd: "#9CCC65",
      pageFrom: "#E8F5E9",
      pageVia: "#F1F8E9",
      pageTo: "#E8F5E9",
      textPrimary: "#1B5E20",
      textSecondary: "#33691E",
      accent: "#689F38",
      accentSoft: "#E8F5E9",
      accentBorder: "#AED581",
    },
  },
  {
    id: "renalife",
    emoji: "🫘",
    label: "RenaLife",
    eyebrow: "RenaLife • Kidney Health Companion",
    subtitle: "Gentle care for the filters that keep you well",
    theme: {
      headerFrom: "#EFEBE9",
      headerVia: "#FFF3E0",
      headerTo: "#D7CCC8",
      topBar: "from-[#BCAAA4] via-[#A1887F] to-[#8D6E63]",
      badgeBg: "#8D6E63",
      titleGradient: "from-[#4E342E] via-[#5D4037] to-[#6D4C41]",
      heart: "#6D4C41",
      subtitle: "#3E2723",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#EFEBE9_0%,#D7CCC8_40%,#BCAAA4_75%,#A1887F_100%)",
      orbitFrom: "#EFEBE9",
      orbitTo: "#D7CCC8",
      glow: "rgba(188,170,164,0.45)",
      lineStart: "#BCAAA4",
      lineEnd: "#A1887F",
      pageFrom: "#EFEBE9",
      pageVia: "#FFF3E0",
      pageTo: "#EFEBE9",
      textPrimary: "#3E2723",
      textSecondary: "#5D4037",
      accent: "#6D4C41",
      accentSoft: "#EFEBE9",
      accentBorder: "#BCAAA4",
    },
  },
  {
    id: "neurolife",
    emoji: "🧠",
    label: "NeuroLife",
    eyebrow: "NeuroLife • Brain & Nerve Companion",
    subtitle: "Clarity, focus, and the quiet strength of a calm mind",
    theme: {
      headerFrom: "#EDE7F6",
      headerVia: "#E8EAF6",
      headerTo: "#D1C4E9",
      topBar: "from-[#B39DDB] via-[#9575CD] to-[#7E57C2]",
      badgeBg: "#7E57C2",
      titleGradient: "from-[#4527A0] via-[#512DA8] to-[#5E35B1]",
      heart: "#5E35B1",
      subtitle: "#311B92",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#EDE7F6_0%,#D1C4E9_40%,#B39DDB_75%,#9575CD_100%)",
      orbitFrom: "#EDE7F6",
      orbitTo: "#D1C4E9",
      glow: "rgba(179,157,219,0.45)",
      lineStart: "#B39DDB",
      lineEnd: "#9575CD",
      pageFrom: "#EDE7F6",
      pageVia: "#E8EAF6",
      pageTo: "#EDE7F6",
      textPrimary: "#311B92",
      textSecondary: "#4527A0",
      accent: "#5E35B1",
      accentSoft: "#EDE7F6",
      accentBorder: "#B39DDB",
    },
  },
  {
    id: "rhythm",
    emoji: "💓",
    label: "RhythmThyro",
    eyebrow: "Rhythm • Thyroid Companion",
    subtitle: "Balancing the quiet conductor of your metabolism",
    theme: {
      headerFrom: "#FFF3E0",
      headerVia: "#FFECB3",
      headerTo: "#FFE0B2",
      topBar: "from-[#FFCC80] via-[#FFB74D] to-[#FFA726]",
      badgeBg: "#FB8C00",
      titleGradient: "from-[#E65100] via-[#EF6C00] to-[#F57C00]",
      heart: "#F57C00",
      subtitle: "#BF360C",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#FFF8E1_0%,#FFECB3_40%,#FFE0B2_75%,#FFCC80_100%)",
      orbitFrom: "#FFF3E0",
      orbitTo: "#FFE0B2",
      glow: "rgba(255,183,77,0.45)",
      lineStart: "#FFCC80",
      lineEnd: "#FFB74D",
      pageFrom: "#FFF3E0",
      pageVia: "#FFECB3",
      pageTo: "#FFF3E0",
      textPrimary: "#E65100",
      textSecondary: "#BF360C",
      accent: "#F57C00",
      accentSoft: "#FFF3E0",
      accentBorder: "#FFCC80",
    },
  },
  {
    id: "thrive",
    emoji: "🌈",
    label: "ThriveGeneral",
    eyebrow: "Thrive • Everyday Wellness",
    subtitle: "Small habits that compound into a brighter you",
    theme: {
      headerFrom: "#E8EAF6",
      headerVia: "#F3E5F5",
      headerTo: "#E1BEE7",
      topBar: "from-[#9FA8DA] via-[#CE93D8] to-[#80CBC4]",
      badgeBg: "#5C6BC0",
      titleGradient: "from-[#303F9F] via-[#5C6BC0] to-[#7E57C2]",
      heart: "#5C6BC0",
      subtitle: "#283593",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#E8EAF6_0%,#C5CAE9_40%,#B39DDB_75%,#9FA8DA_100%)",
      orbitFrom: "#E8EAF6",
      orbitTo: "#C5CAE9",
      glow: "rgba(159,168,218,0.45)",
      lineStart: "#9FA8DA",
      lineEnd: "#CE93D8",
      pageFrom: "#E8EAF6",
      pageVia: "#F3E5F5",
      pageTo: "#E8EAF6",
      textPrimary: "#1A237E",
      textSecondary: "#283593",
      accent: "#5C6BC0",
      accentSoft: "#E8EAF6",
      accentBorder: "#9FA8DA",
    },
  },
  {
    id: "vibe",
    emoji: "✨",
    label: "VibeYouthHealth",
    eyebrow: "Vibe • Youth Health Companion",
    subtitle: "Energy, glow, and the freedom to feel unstoppable",
    theme: {
      headerFrom: "#FFF8E1",
      headerVia: "#FCE4EC",
      headerTo: "#FFF9C4",
      topBar: "from-[#FFF59D] via-[#FFECB3] to-[#FFE082]",
      badgeBg: "#FFCA28",
      titleGradient: "from-[#F9A825] via-[#FBC02D] to-[#FDD835]",
      heart: "#FBC02D",
      subtitle: "#F57F17",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#FFFDE7_0%,#FFF9C4_40%,#FFF59D_75%,#FFEE58_100%)",
      orbitFrom: "#FFF8E1",
      orbitTo: "#FFF9C4",
      glow: "rgba(255,238,88,0.45)",
      lineStart: "#FFF59D",
      lineEnd: "#FFEE58",
      pageFrom: "#FFF8E1",
      pageVia: "#FCE4EC",
      pageTo: "#FFF8E1",
      textPrimary: "#F57F17",
      textSecondary: "#F9A825",
      accent: "#FBC02D",
      accentSoft: "#FFF8E1",
      accentBorder: "#FFF59D",
    },
  },
  {
    id: "udaan",
    emoji: "🕊️",
    label: "Udaan518Health",
    eyebrow: "Udaan • 5-18 Youth Companion",
    subtitle: "Growing strong minds and bodies, one day at a time",
    theme: {
      headerFrom: "#E0F7FA",
      headerVia: "#E1F5FE",
      headerTo: "#B2EBF2",
      topBar: "from-[#80DEEA] via-[#4DD0E1] to-[#26C6DA]",
      badgeBg: "#00ACC1",
      titleGradient: "from-[#006064] via-[#00838F] to-[#00ACC1]",
      heart: "#00ACC1",
      subtitle: "#006064",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#E0F7FA_0%,#B2EBF2_40%,#80DEEA_75%,#4DD0E1_100%)",
      orbitFrom: "#E0F7FA",
      orbitTo: "#B2EBF2",
      glow: "rgba(128,222,234,0.45)",
      lineStart: "#80DEEA",
      lineEnd: "#4DD0E1",
      pageFrom: "#E0F7FA",
      pageVia: "#E1F5FE",
      pageTo: "#E0F7FA",
      textPrimary: "#006064",
      textSecondary: "#00838F",
      accent: "#00ACC1",
      accentSoft: "#E0F7FA",
      accentBorder: "#80DEEA",
    },
  },
  {
    id: "hopelife",
    emoji: "🎗️",
    label: "HopeLifeOnco",
    eyebrow: "HopeLife • Oncology Companion",
    subtitle: "Courage, care, and hope — every step of the journey",
    theme: {
      headerFrom: "#F3E5F5",
      headerVia: "#EDE7F6",
      headerTo: "#E1BEE7",
      topBar: "from-[#CE93D8] via-[#B39DDB] to-[#BA68C8]",
      badgeBg: "#9C27B0",
      titleGradient: "from-[#6A1B9A] via-[#7B1FA2] to-[#8E24AA]",
      heart: "#8E24AA",
      subtitle: "#4A148C",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#F3E5F5_0%,#E1BEE7_40%,#CE93D8_75%,#BA68C8_100%)",
      orbitFrom: "#F3E5F5",
      orbitTo: "#E1BEE7",
      glow: "rgba(206,147,216,0.45)",
      lineStart: "#CE93D8",
      lineEnd: "#BA68C8",
      pageFrom: "#F3E5F5",
      pageVia: "#EDE7F6",
      pageTo: "#F3E5F5",
      textPrimary: "#4A148C",
      textSecondary: "#6A1B9A",
      accent: "#8E24AA",
      accentSoft: "#F3E5F5",
      accentBorder: "#CE93D8",
    },
  },
  {
    id: "podia",
    emoji: "🦶",
    label: "PodiaFootHealth",
    eyebrow: "Podia • Foot Health Companion",
    subtitle: "Steady steps start with healthy feet",
    theme: {
      headerFrom: "#EFEBE9",
      headerVia: "#F5F5F5",
      headerTo: "#D7CCC8",
      topBar: "from-[#BCAAA4] via-[#A1887F] to-[#8D6E63]",
      badgeBg: "#795548",
      titleGradient: "from-[#3E2723] via-[#4E342E] to-[#5D4037]",
      heart: "#5D4037",
      subtitle: "#3E2723",
      centerGradient:
        "radial-gradient(circle_at_30%_28%,#EFEBE9_0%,#D7CCC8_40%,#BCAAA4_75%,#A1887F_100%)",
      orbitFrom: "#EFEBE9",
      orbitTo: "#D7CCC8",
      glow: "rgba(188,170,164,0.4)",
      lineStart: "#BCAAA4",
      lineEnd: "#A1887F",
      pageFrom: "#EFEBE9",
      pageVia: "#F5F5F5",
      pageTo: "#EFEBE9",
      textPrimary: "#3E2723",
      textSecondary: "#5D4037",
      accent: "#5D4037",
      accentSoft: "#EFEBE9",
      accentBorder: "#BCAAA4",
    },
  },
];

export default function LifeNHealthHeaderBanner({
  selectedId = "maternity",
  onSelect,
}) {
  const selected =
    PRODUCTS.find((p) => p.id === selectedId) ?? PRODUCTS[0];
  const { theme } = selected;

  const orbitPositions = useMemo(() => {
    const count = PRODUCTS.length;
    const radius = 42;
    return PRODUCTS.map((product, i) => {
      const angle = (i / count) * 2 * Math.PI - Math.PI / 2;
      const x = 50 + radius * Math.cos(angle);
      const y = 50 + radius * Math.sin(angle);
      return {
        ...product,
        style: {
          left: `${x}%`,
          top: `${y}%`,
          transform: "translate(-50%, -50%)",
        },
      };
    });
  }, []);

  return (
    <header
      className="relative z-20 overflow-hidden rounded-b-3xl px-5 pt-8 pb-10 sm:pt-10 sm:pb-12 text-center shadow-[0_20px_50px_-20px_rgba(0,0,0,0.12)] transition-colors duration-500"
      style={{
        background: `linear-gradient(to bottom right, ${theme.headerFrom}, ${theme.headerVia}, ${theme.headerTo})`,
      }}
    >
      <div
        className={`absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r ${theme.topBar}`}
      />
      <div
        className="absolute -top-20 left-1/2 -translate-x-1/2 h-56 w-80 rounded-full blur-[90px] opacity-80"
        style={{ backgroundColor: theme.headerFrom }}
        aria-hidden="true"
      />

      <div
        className="relative inline-flex items-center gap-1.5 rounded-full border border-white/60 px-3 py-1 text-[0.62rem] font-mono uppercase tracking-[0.2em] text-white transition-colors duration-300"
        style={{ backgroundColor: theme.badgeBg }}
      >
        <span
          className="h-1.5 w-1.5 rounded-full bg-white/80 motion-safe:animate-pulse"
          aria-hidden="true"
        />
        {selected.eyebrow}
      </div>

      <h1 className="relative mt-3 font-display text-[1.6rem] sm:text-[1.9rem] font-semibold">
        <span
          className={`bg-gradient-to-r ${theme.titleGradient} bg-clip-text text-transparent`}
        >
          LifeNHealth
        </span>{" "}
        <span style={{ color: theme.heart }} aria-hidden="true">
          ♥
        </span>
      </h1>

      <p
        className="relative mt-2 text-[0.82rem] sm:text-sm transition-colors duration-300"
        style={{ color: theme.subtitle }}
      >
        {selected.subtitle}
      </p>

      {/* Refined positioning line */}
      <p
        className="relative mt-2.5 mx-auto max-w-md text-[0.78rem] sm:text-[0.84rem] leading-relaxed font-medium"
        style={{ color: theme.subtitle }}
      >
        Your data companion for betterment —{" "}
        <span className="opacity-90">
          optional collaboration between you, your family, doctors & clinics,
          and pharma insights.
        </span>
      </p>

      {/* Subtle ecosystem note */}
      <p
        className="relative mt-1.5 mx-auto max-w-sm text-[0.68rem] sm:text-[0.72rem] leading-snug opacity-80"
        style={{ color: theme.subtitle }}
      >
        AI prompts that surface insights from <em>your actual data</em> — not
        generic GenAI.
        <br />
        Part of a quieter ecosystem simplifying data & AI for humanity in day to day life.
      </p>

      <div className="relative mx-auto mt-8 sm:mt-10 aspect-square w-full max-w-[340px] sm:max-w-[400px]">
        <div
          className="absolute inset-0 rounded-full blur-2xl opacity-70"
          style={{
            background: `radial-gradient(circle at center, ${theme.headerFrom} 0%, ${theme.headerTo}55 40%, transparent 70%)`,
          }}
          aria-hidden="true"
        />
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-48 w-48 sm:h-56 sm:w-56 rounded-full blur-3xl motion-safe:animate-pulse opacity-60"
          style={{
            background: `linear-gradient(to bottom right, ${theme.headerFrom}cc, ${theme.headerVia}99, ${theme.headerTo}aa)`,
          }}
          aria-hidden="true"
        />

        <svg
          className="absolute inset-0 w-full h-full pointer-events-none z-0"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient
              id="lineGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor={theme.lineStart} stopOpacity="0.4" />
              <stop offset="100%" stopColor={theme.lineEnd} stopOpacity="0.3" />
            </linearGradient>
          </defs>
          {orbitPositions.map((item) => {
            const x = parseFloat(item.style.left);
            const y = parseFloat(item.style.top);
            return (
              <line
                key={item.id}
                x1="50"
                y1="50"
                x2={x}
                y2={y}
                stroke="url(#lineGradient)"
                strokeWidth="0.55"
                strokeLinecap="round"
              />
            );
          })}
        </svg>

        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
          <div
            className="relative flex h-28 w-28 sm:h-32 sm:w-32 items-center justify-center rounded-full ring-1 ring-white/70 transition-all duration-500"
            style={{
              background: theme.centerGradient,
              boxShadow: `0 0 50px -6px ${theme.glow}, 0 0 28px -4px ${theme.glow}`,
            }}
          >
            <span
              className="text-5xl sm:text-6xl select-none drop-shadow-sm"
              aria-hidden="true"
            >
              {selected.emoji}
            </span>
          </div>
        </div>

        {orbitPositions.map((item) => {
          const isActive = item.id === selectedId;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelect?.(item.id)}
              className={`absolute z-10 flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full
                border transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
                ${isActive ? "scale-110 border-white/90 shadow-lg" : "border-white/65 hover:scale-110 hover:border-white/90"}`}
              style={{
                ...item.style,
                background: `linear-gradient(to bottom right, ${theme.orbitFrom}ee, ${theme.orbitTo}f5)`,
                boxShadow: isActive
                  ? `0 0 28px -4px ${theme.glow}`
                  : "0 8px 24px -8px rgba(0,0,0,0.12)",
                backdropFilter: "blur(8px)",
              }}
              aria-label={`Select ${item.label}`}
              aria-pressed={isActive}
            >
              <span
                className="text-xl sm:text-2xl select-none"
                aria-hidden="true"
              >
                {item.emoji}
              </span>
            </button>
          );
        })}
      </div>
    </header>
  );
}